import {X_LANGUAGE_CODE} from '../../shared/types';

export const getHeaderLanguageCode = (languageCode?: string | null) => {
  const headers: HeadersInit = {};
  if (languageCode && languageCode.length === 2) {
    headers[X_LANGUAGE_CODE] = languageCode;
  }
  return headers;
};

export const getLanguageCode = (pathname: string) => {
  const matcher = new RegExp(/^\/(\w\w)\//);
  const matchingLang = pathname.match(matcher);
  const languageCode = matchingLang && matchingLang[1].trim();

  return languageCode;
};

export const getLanguagePath = (pathname: string) => {
  const code = getLanguageCode(pathname);
  return code ? `/${code}` : '';
};

export const getRoutePath = (pathname: string) => {
  /* Remove language and trailing slashes from path */
  const languagePath = getLanguagePath(pathname);
  return pathname.replace(languagePath, '').replace(/\/$/, '');
};
